import { Hold } from './Hold';
import { DelopgaveListItem } from './DelopgaveListItem';
import { OpgaveListItem } from './OpgaveListItem'; 
export class ScoreboardKonfiguration {
        public id: string;
        public navn: string;
        public valgteOpgavepakkeId: string;
        public valgteHold: Hold[];
        public valgteDelopgaver: DelopgaveListItem[];
        public valgteOpgaver: OpgaveListItem[];
        public konkurrenceId: string;
        public showSamletPlacering: boolean;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/ScoreboardKonfiguration.ts